import { createFileRoute } from '@tanstack/react-router'

import { duplicateFilters } from '@/features/cards/duplicate-filters'
import { DuplicatesPage } from '@/features/cards/duplicates-page'

export const Route = createFileRoute('/_app/cards/duplicates')({
    validateSearch: duplicateFilters.parse,
    component: DuplicatesPage,
    staticData: { crumb: 'Duplicates' }
})
